import React from 'react';
import Services from '../components/Services';

const ServicesPage = () => {
  return (
    <div className="container">
      <div className="page-section animate-fade-in-up animate-stagger">
        <Services />
      </div>
    </div>
  );
};

export default ServicesPage;
